export enum Frequency {
    Weekly = 0,
    Monthly,
    Quarterly,
    Annually
  }
  